import { useState } from "react"
import { XCircle } from "lucide-react"
import { useCloseOrderRequestMutation } from "shared/redux/endpoints/procurementApprovals"
import { showToastSuccess, showToastError } from "utilities/toastUtil"
import { Button, Textarea } from "../../ui"
import { getApiErrorMessage } from "../../orderSubmitFeedback"

const CloseOrderButton = ({ order, onClosed }) => {
  const [open, setOpen] = useState(false)
  const [note, setNote] = useState("")
  const [closeOrder, { isLoading }] = useCloseOrderRequestMutation()

  if (!(order?.allowedActions || []).includes("close")) return null

  const cancel = () => {
    if (isLoading) return
    setOpen(false)
    setNote("")
  }

  const confirm = async () => {
    try {
      await closeOrder({ id: order.id, note: note.trim() }).unwrap()
      setOpen(false)
      setNote("")
      showToastSuccess("Order closed.")
      onClosed?.()
    } catch (e) {
      showToastError(getApiErrorMessage(e, "Couldn't close this order. Please try again."))
    }
  }

  return (
    <>
      <Button variant="secondary" leftIcon={<XCircle aria-hidden />} onClick={() => setOpen(true)}>
        Close order
      </Button>
      {open && (
        <div
          className="pc-modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.target === e.currentTarget && cancel()}
        >
          <div className="pc-modal">
            <div className="pc-modal-head">
              <div className="pc-modal-title">Close order {order.orCode}</div>
            </div>
            <div className="pc-modal-body">
              <Textarea
                label="Note"
                required
                rows={4}
                placeholder="Why is this order being closed?"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                disabled={isLoading}
              />
            </div>
            <div className="pc-modal-foot">
              <Button variant="secondary" onClick={cancel} disabled={isLoading}>
                Go back
              </Button>
              <Button variant="primary" onClick={confirm} disabled={isLoading || !note.trim()}>
                {isLoading ? "Closing…" : "Close order"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CloseOrderButton
